import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, resolvePostAuthPath } from "@/context/AuthContext";
import { toast } from "@/components/ui/sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();
    const { googleSession } = useAuth();
    const [error, setError] = useState("");

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login");
            return;
        }
        const sessionId = match[1];
        const role = localStorage.getItem("simonara_auth_role") || "professional";

        (async () => {
            try {
                const user = await googleSession(sessionId, role);
                localStorage.removeItem("simonara_auth_role");
                window.history.replaceState(null, "", window.location.pathname);
                const path = await resolvePostAuthPath(user);
                navigate(path, { state: { user }, replace: true });
            } catch (e) {
                setError("Google sign-in failed. Please try again.");
                toast.error("Google sign-in failed. Please try again.");
                setTimeout(() => navigate("/login", { replace: true }), 1500);
            }
        })();
    }, [googleSession, navigate]);

    return (
        <div className="min-h-[70vh] flex flex-col items-center justify-center gap-4 bg-background" data-testid="auth-callback-loading">
            <Loader2 size={28} className="animate-spin text-emerald-500" />
            <p className="text-sm text-muted-foreground">{error || "Signing you in…"}</p>
        </div>
    );
}
